import { render } from "./index.vue?vue&type=template&id=6f0c45e7&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=6f0c45e7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f0c45e7"],['__file',"src/components/BaseUi/InfoPopup/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f0c45e7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f0c45e7', __exports__)) {
    api.reload('6f0c45e7', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=6f0c45e7&scoped=true", () => {
    api.rerender('6f0c45e7', render)
  })

}


export default __exports__